<template>
  <div>
    <app-notification :title="'קרתה תקלה, התזרים לא מעודכן.'"
                  :text="'הצוות שלנו עובד כדי לתקן אותה מהר! נשלח לך לינק לתזרים מעודכן ברגע שהיא תיפתר.'"
                  :footer-button="footerButton"
                  :icon-type="'danger'"/>
  </div>
</template>

<script>
import Intercom from '@/Intercom';
import Segment from '../../../../../../../Segment';
import AppNotification from '../AppNotification.vue';

export default {
  name: 'OutOfDateNotification',
  components: {
    AppNotification,
  },
  async created() {
    Segment.trackUserGot('OutOfDateNotificationShown');
    Segment.trackUserInteraction('JustInTimeCX_Shown', { source: this.$options.name });
  },
  computed: {
    footerButton() {
      return {
        title: 'לצ׳אט עם הצוות',
        variant: 'flat-black',
        size: 'slim',
        action: this.handleIntercomClickAction,
        // eslint-disable-next-line global-require
        icon: require('@/assets/icons/chat_icon_teriatry.svg'),
        id: 'cx-just-in-time-tech-error-footer-button',
      };
    },
  },
  methods: {
    handleIntercomClickAction() {
      Segment.trackUserInteraction('JustInTimeCX_Clicked', { source: this.$options.name });
      Intercom.showNewMessage('');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
